import { M as Manipulation } from "./manipulation-swiper.js";
import { N as Navigation, S as Swiper } from "./navigation.chunk.js";
import { P as Pagination, T as Thumb } from "./thumbs.chunk.js";

if (!customElements.get("html-update-utility")) {
  customElements.define(
    "html-update-utility",
    class HTMLUpdateUtility {
      /**
       * Used to swap an HTML node with a new node.
       * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
       *
       * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
       */
      static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        preProcessCallbacks?.forEach((callback) => callback(newContent));

        const newNodeWrapper = document.createElement("div");
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;

        // dedupe IDs
        const uniqueKey = Date.now();
        oldNode.querySelectorAll("[id], [form]").forEach((element) => {
          element.id && (element.id = `${element.id}-${uniqueKey}`);
          element.form && element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
        });

        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = "none";

        postProcessCallbacks?.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 500);
      }

      // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }
  );
}
if (!customElements.get("product-card-product-form")) {
  customElements.define(
    "product-card-product-form",

    class ProductCardProductForm extends HTMLElement {
      constructor() {
        super();
        this.available_variants_list = this.closest("available-variants-list");
        this.buttonAdd = this.querySelector('button[name="add"]') || this.querySelector("button[js-add-to-cart-btn]");
      }

      connectedCallback() {
        this.listenEvents();
      }

      listenEvents() {
        this.buttonAdd.addEventListener("click", () => this.handleSubmit());
        // Écouter l'événement sur le product-card parent
        const productCard = this.closest("product-card");
        if (productCard) {
          productCard.addEventListener("variant:change", (event) => this.onVariantChange(event));
        }
      }

      get variantId() {
        return parseInt(this.querySelector('input[name="id"]').value);
      }

      onVariantChange(event) {
        this.toggleAvailability(event);
        this.querySelector('input[name="id"]').value = event.detail.variant.id;
      }

      toggleAvailability(event) {
        let available = event.detail.variant.available;
        let preorder = event.detail.preorder;

        this.buttonAddLabel = this.buttonAdd.querySelector("#mainText");

        if (available === false) {
          this.buttonAddLabel.innerHTML = this.dataset.soldout;
          this.buttonAdd.setAttribute("disabled", true);
          this.buttonAdd.classList.add("button--disabled");
        } else {
          // Vérifier si preorder est falsy (null, undefined, false, 0, "")
          const isPreorder = preorder && preorder !== false && preorder !== 0 && preorder !== "";
          this.buttonAddLabel.innerHTML = isPreorder ? this.dataset.preorder : this.dataset.available;

          this.buttonAdd.removeAttribute("disabled");
          this.buttonAdd.classList.remove("button--disabled");
        }
      }

      handleSubmit(event) {
        let formData;
        formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1,
            },
          ],
        };

        if (this.querySelector('input[name="properties[Précommande]"]')) {
          formData.items[0].properties = {
            Précommande: this.querySelector('input[name="properties[Précommande]"]').value,
          };
        }

        if (this.querySelector('input[name="items[0][selling_plan]"]')) {
          formData.items[0].selling_plan = this.querySelector('input[name="items[0][selling_plan]"]').value;
        }

        this.fetchItem(formData);
      }

      fetchItem(data) {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {

            // Si rebuyAppEmbedEnabled est true et qu'on est sur Safari, rediriger vers la page panier à supprimer une fois soucis résolu par rebuy
            if (typeof Rebuy === "undefined") {
              window.location.href = "/cart";
            } else {
              return data;
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      convertEventSub() {
        window._conv_q = window._conv_q || [];
        _conv_q.push(["triggerConversion", "100430143"]);
      }
    }
  );
}
if (!customElements.get("product-card")) {
  customElements.define(
    "product-card",

    class ProductCard extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}

if (!customElements.get("available-variants-list")) {
  customElements.define(
    "available-variants-list",

    class AvailableVariantsList extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // Vérifier si le parent product-card a le comportement "change_variant_displayed"
        const productCard = this.closest("product-card");
        const swatchesBehavior = productCard?.getAttribute("data-swatches-behavior");

        if (swatchesBehavior === "change_variant_displayed") {
          this.setupVariantClickHandler();
        }
      }

      setupVariantClickHandler() {
        // Trouver tous les liens de variantes dans ce available-variants-list
        const variantLinks = this.querySelectorAll("a");

        variantLinks.forEach((link) => {
          link.addEventListener("click", (event) => {
            // Empêcher la redirection
            event.preventDefault();

            // Récupérer les données de la variante
            const variantId = link.getAttribute("data-variant-id");
            const variantName = link.getAttribute("data-variant-name");
            const href = link.getAttribute("href");

            // Mettre à jour l'affichage de la variante
            this.updateVariantDisplay(variantId, variantName, href);
          });
        });
      }

      updateVariantDisplay(variantId, variantName, variantUrl) {
        // Mettre à jour l'état visuel des variantes
        this.updateVariantSelection(variantId);

        // Fetch les données de la variante
        this.fetchVariantData(variantId);
      }

      updateVariantSelection(variantId) {
        // Supprimer la classe selected de toutes les variantes
        const allVariantLinks = this.querySelectorAll("a");
        allVariantLinks.forEach((link) => {
          link.classList.remove("available-variant-item-selected");
        });

        // Marquer la variante sélectionnée
        const selectedLink = this.querySelector(`a[data-variant-id="${variantId}"]`);
        if (selectedLink) {
          selectedLink.classList.add("available-variant-item-selected");
        }
      }

      async fetchVariantData(variantId) {
        try {
          // Récupérer l'handle du produit depuis l'URL
          const productCard = this.closest("product-card");
          const productUrl = productCard?.querySelector("a[href*='/products/']")?.getAttribute("href");

          if (!productUrl) {
            console.error("Impossible de trouver l'URL du produit");
            return;
          }

          // Extraire le handle du produit depuis l'URL
          const handleMatch = productUrl.match(/\/products\/([^\/\?]+)/);
          if (!handleMatch) {
            console.error("Impossible d'extraire le handle du produit");
            return;
          }

          const productHandle = handleMatch[1];

          // Fetch direct vers l'API Shopify
          const apiUrl = `/products/${productHandle}.js`;
          const response = await fetch(apiUrl);
          const productData = await response.json();

          // Trouver la variante cliquée
          const selectedVariant = productData.variants.find((variant) => variant.id == variantId);

          if (selectedVariant) {
            // Dispatcher l'événement depuis le product-card parent
            const productCard = this.closest("product-card");
            if (productCard) {
              productCard.dispatchEvent(
                new CustomEvent("variant:change", {
                  detail: {
                    variant: selectedVariant,
                    preorder: selectedVariant.metafields?.preorder?.active || false,
                  },
                })
              );
            }

            this.updateProductImage(selectedVariant);
          } else {
          }
        } catch (error) {
          console.error("Erreur lors du fetch des données du produit:", error);
        }
      }

      updateProductImage(selectedVariant) {
        // Vérifier si la variante a une image
        if (!selectedVariant.featured_media || !selectedVariant.featured_media.preview_image) {
          console.log("Aucune image trouvée pour cette variante");
          return;
        }

        // Trouver l'image du produit dans la carte
        const productCard = this.closest("product-card");
        const productImage = productCard?.querySelector("a img");

        if (!productImage) {
          console.log("Image du produit non trouvée dans la carte");
          return;
        }

        const imageData = selectedVariant.featured_media.preview_image;

        // Mettre à jour l'image avec un effet de transition
        productImage.style.opacity = "0.5";
        productImage.style.transition = "opacity 0.3s ease";

        // Mettre à jour le src
        productImage.src = imageData.src;

        // Générer le srcset dynamiquement
        const srcset = this.generateSrcset(imageData.src);
        productImage.srcset = srcset;

        // Mettre à jour l'alt
        productImage.alt = selectedVariant.title || productImage.alt;

        // Attendre que l'image soit chargée avant de restaurer l'opacité
        productImage.onload = () => {
          productImage.style.opacity = "1";
        };

        // Fallback si l'image ne se charge pas
        productImage.onerror = () => {
          productImage.style.opacity = "1";
        };
      }

      generateSrcset(imageSrc) {
        // Tailles inspirées de jolly-render-image.liquid
        const sizes = [220, 300, 600, 900];
        const srcsetParts = [];

        sizes.forEach((size) => {
          // Remplacer la largeur dans l'URL (même logique que Liquid)
          const sizedImageSrc = imageSrc.replace(/\.(jpg|jpeg|png|webp)/, `_${size}x.$1`);
          srcsetParts.push(`${sizedImageSrc} ${size}w`);
        });

        return srcsetParts.join(", ");
      }
    }
  );
}

if (!customElements.get("product-card-quick-add-modal-opener")) {
  class ProductCardQuickAddModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector("button");

      if (!button) return;
      button.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define("product-card-quick-add-modal-opener", ProductCardQuickAddModalOpener);
}

if (!customElements.get("modal-dialog")) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });
      if (this.classList.contains("media-modal")) {
        this.addEventListener("pointerup", (event) => {
          if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
        });
      } else {
        this.addEventListener("click", (event) => {
          if (event.target === this) this.hide();
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }

    hide() {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define("modal-dialog", ModalDialog);
}

// Fonction pour gérer le changement d'image lors du changement de variante dans la modal
function setupModalImageVariantHandler(modalContent) {
  const imageContainer = modalContent.querySelector("[data-modal-image-container]");
  if (!imageContainer) return;

  const img = imageContainer.querySelector("img");
  if (!img) return;

  // Fonction pour mettre à jour l'image
  const updateModalImage = () => {
    // Chercher le variant-picker (peut être variant-picker-reusable dans la modal)
    const variantPicker = modalContent.querySelector("variant-picker-reusable") || modalContent.querySelector("variant-picker");

    if (!variantPicker) return;

    const variantsJSON = variantPicker.querySelector("[data-product-variants-json]");
    if (!variantsJSON) return;

    const checkedInputs = variantPicker.querySelectorAll(".js-variants-update:checked");
    if (checkedInputs.length === 0) return;

    const parsedVariantsJSON = JSON.parse(variantsJSON.textContent);
    const checkedOption = Array.from(checkedInputs, (input) => input.value);
    const currentVariant = parsedVariantsJSON.find((variant) => variant.options.join(",") === checkedOption.join(","));

    if (currentVariant && currentVariant.featured_image) {
      // Ajouter une transition smooth
      img.style.opacity = "0.5";
      img.style.transition = "opacity 0.3s ease";

      // Mettre à jour l'image
      img.src = currentVariant.featured_image.src;
      img.alt = currentVariant.featured_image.alt || currentVariant.name;

      // Générer le srcset
      if (currentVariant.featured_image.src) {
        const srcset = generateImageSrcset(currentVariant.featured_image.src);
        img.srcset = srcset;
      }

      // Restaurer l'opacité une fois l'image chargée
      img.onload = () => {
        img.style.opacity = "1";
      };
    }
  };

  // Utiliser la délégation d'événements sur modalContent pour capturer tous les clics
  modalContent.addEventListener("click", (event) => {
    const variantInput = event.target.closest(".js-variants-update");
    if (variantInput && variantInput.type === "radio") {
      // Attendre que le radio soit bien coché avant de mettre à jour
      setTimeout(() => {
        updateModalImage();
      }, 50);
    }
  });

  // Aussi écouter l'événement variant:change si disponible
  const productCard = modalContent.querySelector("product-card");
  if (productCard) {
    productCard.addEventListener("variant:change", (event) => {
      const variant = event.detail.variant;

      if (variant && variant.featured_image) {
        img.style.opacity = "0.5";
        img.style.transition = "opacity 0.3s ease";
        img.src = variant.featured_image.src;
        img.alt = variant.featured_image.alt || variant.name;

        if (variant.featured_image.src) {
          const srcset = generateImageSrcset(variant.featured_image.src);
          img.srcset = srcset;
        }

        img.onload = () => {
          img.style.opacity = "1";
        };
      }
    });
  }

  // Mettre à jour l'image initiale au chargement
  setTimeout(() => {
    updateModalImage();
  }, 100);
}

// Fonction utilitaire pour générer le srcset
function generateImageSrcset(imageSrc) {
  const sizes = [220, 300, 600, 900];
  const srcsetParts = [];

  sizes.forEach((size) => {
    // Extraire l'extension et créer l'URL redimensionnée
    const extension = imageSrc.match(/\.(jpg|jpeg|png|webp|gif)(\?|$)/i);
    if (extension) {
      const sizedImageSrc = imageSrc.replace(/\.(jpg|jpeg|png|webp|gif)(\?|$)/i, `_${size}x.${extension[1]}$2`);
      srcsetParts.push(`${sizedImageSrc} ${size}w`);
    }
  });

  return srcsetParts.join(", ");
}

if (!customElements.get("product-card-quick-add-modal")) {
  // Attendre que ModalDialog soit définie
  const defineQuickAddModal = () => {
    if (customElements.get("modal-dialog")) {
      customElements.define(
        "product-card-quick-add-modal",
        class ProductCardQuickAddModal extends customElements.get("modal-dialog") {
          constructor() {
            super();
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

            this.addEventListener("product-info:loaded", ({ target }) => {
              target.addPreProcessCallback(this.preprocessHTML.bind(this));
            });
          }

          hide(preventFocus = false) {
            const cartNotification = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            if (cartNotification) cartNotification.setActiveElement(this.openedBy);
            this.modalContent.innerHTML = "";

            if (preventFocus) this.openedBy = null;
            super.hide();
          }

          show(opener) {
            opener.setAttribute("aria-disabled", true);

            fetch(opener.getAttribute("data-product-url"))
              .then((response) => response.text())
              .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
                const productElement = responseHTML.querySelector(".js-main-product");

                if (!productElement) {
                  console.error(".js-main-product element not found in response");
                  return;
                }

                this.preprocessHTML(productElement);

                // Remplacer variant-picker par variant-picker-reusable dans la modal (mais pas upsell-variant-picker)
                const htmlContent = productElement.outerHTML;
                const updatedHtmlContent = htmlContent
                  .replace(/<variant-picker\b/g, "<variant-picker-reusable")
                  .replace(/<\/variant-picker>/g, "</variant-picker-reusable>");

                // Utiliser directement la méthode setInnerHTML
                this.modalContent.innerHTML = updatedHtmlContent;

                // Réinjecter les scripts pour permettre leur exécution
                this.modalContent.querySelectorAll("script").forEach((oldScriptTag) => {
                  const newScriptTag = document.createElement("script");
                  Array.from(oldScriptTag.attributes).forEach((attribute) => {
                    newScriptTag.setAttribute(attribute.name, attribute.value);
                  });
                  newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                  oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });

                // Réinitialiser les variant pickers dans la modal
                setTimeout(() => {
                  // Initialiser les variant pickers si nécessaire
                  if (window.VariantPickerUtils) {
                    window.VariantPickerUtils.initAll();
                  }

                  // Configurer le gestionnaire de changement d'image pour les variantes
                  setupModalImageVariantHandler(this.modalContent);

                  // Gérer les formulaires d'ajout au panier dans la modal
                  setupCartFormHandlers(this.modalContent);

                  // Gérer le loading pour les produits sans module d'abonnement
                  removeLoadingIfNoSubscription(this.modalContent);
                }, 100);

                if (window.Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
                if (window.ProductModel) window.ProductModel.loadShopifyXR();

                super.show(opener);
              })
              .finally(() => {
                opener.removeAttribute("aria-disabled");
              });
          }

          preprocessHTML(productElement) {
            // Vérifier et réinitialiser modalContent si nécessaire
            if (!this.modalContent) {
              this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

              // Si toujours null, essayer d'autres sélecteurs
              if (!this.modalContent) {
                this.modalContent = this.querySelector(".quick-add-modal__content-info");
              }
            }

            if (!this.modalContent) {
              console.error("modalContent is still null, cannot preprocess HTML");
              return;
            }

            productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith("color-") || classApplied === "gradient") this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs(productElement);
            this.removeDOMElements(productElement);
            this.removeGalleryListSemantic(productElement);
            this.updateImageSizes(productElement);
            this.preventVariantURLSwitching(productElement);
          }

          preventVariantURLSwitching(productElement) {
            productElement.setAttribute("data-update-url", "false");
          }

          replaceCarouselWithImageContainer(productCarousel, productElement) {
            // Récupérer la première image du slider principal
            const firstSlide = productCarousel.querySelector("#productMainSlider .swiper-slide img");

            if (!firstSlide) {
              productCarousel.remove();
              return;
            }

            // Créer un conteneur pour l'image unique
            const imageContainer = document.createElement("div");
            imageContainer.className = "quick-add-modal__image-container jc-pt-6 jc-px-4 md:jc-px-0";
            imageContainer.setAttribute("data-modal-image-container", "");

            // Cloner l'image
            const img = document.createElement("img");
            img.src = firstSlide.src;
            img.srcset = firstSlide.srcset || "";
            img.alt = firstSlide.alt || "";
            img.className = "quick-add-modal__image jc-w-full jc-h-full jc-object-cover";
            img.loading = "eager";

            imageContainer.appendChild(img);

            // Remplacer le carousel par le conteneur d'image
            productCarousel.parentNode.replaceChild(imageContainer, productCarousel);
          }

          removeDOMElements(productElement) {
            const pickupAvailability = productElement.querySelector("pickup-availability");
            if (pickupAvailability) pickupAvailability.remove();

            const productModal = productElement.querySelector("product-modal");
            if (productModal) productModal.remove();

            const modalDialog = productElement.querySelectorAll("modal-dialog");
            if (modalDialog) modalDialog.forEach((modal) => modal.remove());

            const productCarousel = productElement.querySelector(".product-carousel");
            if (productCarousel) {
              // Remplacer le carousel par un conteneur d'image simple
              this.replaceCarouselWithImageContainer(productCarousel, productElement);
            }

            const reassurancesPharmacy = productElement.querySelector(".reassurance-pharmacie_container");
            if (reassurancesPharmacy) reassurancesPharmacy.remove();

            const productTitle = productElement.querySelector(".jc-h1-title");
            if (productTitle) productTitle.remove();

            const reviewBlock = productElement.querySelector(".jc-reviews-block");
            if (reviewBlock) reviewBlock.remove();

            const deployerStories = productElement.querySelector("deployer-stories");
            if (deployerStories) deployerStories.remove();

            const upsellProduct = productElement.querySelector("upsell-product");
            //if (upsellProduct) upsellProduct.remove();

            const atcReviews = productElement.querySelector(".atc-reviews");
            if (atcReviews) atcReviews.remove();

            const accordionsWrapper = productElement.querySelectorAll(".accordion-wrapper");
            if (accordionsWrapper) accordionsWrapper.forEach((accordion) => accordion.remove());

            const jollyStickyAtc = productElement.querySelector(".jolly-sticky-atc");
            if (jollyStickyAtc) jollyStickyAtc.style.display = "none";
          }

          preventDuplicatedIDs(productElement) {
            const sectionId = productElement.dataset.section;

            const oldId = sectionId;
            const newId = `quickadd-${sectionId}`;
            productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
            Array.from(productElement.attributes).forEach((attribute) => {
              if (attribute.value.includes(oldId)) {
                productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
              }
            });

            productElement.dataset.originalSection = sectionId;
          }

          removeGalleryListSemantic(productElement) {
            const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
            if (!galleryList) return;

            galleryList.setAttribute("role", "presentation");
            galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute("role", "presentation"));
          }

          updateImageSizes(productElement) {
            const product = productElement.querySelector(".product");
            const desktopColumns = product?.classList.contains("product--columns");
            if (!desktopColumns) return;

            const mediaImages = product.querySelectorAll(".product__media img");
            if (!mediaImages.length) return;

            let mediaImageSizes = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

            if (product.classList.contains("product--medium")) {
              mediaImageSizes = mediaImageSizes.replace("715px", "605px");
            } else if (product.classList.contains("product--small")) {
              mediaImageSizes = mediaImageSizes.replace("715px", "495px");
            }

            mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
          }
        }
      );
    } else {
      // Si ModalDialog n'est pas encore définie, attendre
      setTimeout(defineQuickAddModal, 100);
    }
  };

  // Méthode pour supprimer le loading si pas de module d'abonnement
  function removeLoadingIfNoSubscription(modalContent) {
    const subscriptionSystemEnabled = modalContent.querySelector(".jc-subscripiton-system");
    if (!subscriptionSystemEnabled) {
      const subscriptionLoadingElements = modalContent.querySelectorAll("[data-subscription-loading]");
      const loadingIcons = modalContent.querySelectorAll(".jc-loading-icon");

      subscriptionLoadingElements.forEach((el) => {
        el.classList.remove("jc-loading");
        el.classList.add("jc-loaded");
      });

      loadingIcons.forEach((icon) => {
        icon.style.display = "none";
      });
    }
  }

  // Méthode pour gérer les formulaires d'ajout au panier dans la modal
  function setupCartFormHandlers(modalContent) {
    // Gérer les formulaires d'ajout au panier dans la modal
    const cartForms = modalContent.querySelectorAll('form[action="/cart/add"]');

    cartForms.forEach((form) => {
      form.addEventListener("submit", (event) => {
        event.preventDefault();

        // Utiliser la logique d'ajout au panier existante
        const formData = new FormData(form);

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            // Déclencher l'événement d'ajout au panier
            document.dispatchEvent(
              new CustomEvent("cart:add", {
                detail: { items: [data] },
              })
            );

            // Fermer la modal
            const modal = modalContent.closest("product-card-quick-add-modal");
            if (modal) {
              modal.hide();
            }

            // Afficher une notification si disponible
            const cartNotification = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            if (cartNotification) {
              cartNotification.renderContents(data);
            }
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
          });
      });
    });
  }

  defineQuickAddModal();
}
